<template>
  <section>
    <div style="display: flex; flex-direction: column; background: #f8f9fc;">
      <div v-if="isLogoVisible" style="display: flex; justify-content: left;">
        <img
          src="@/assets/icons/ic-system-viabus.svg"
          style="margin-top: 19px; margin-left: 16px;"
        />
      </div>
      <div
        style="position: absolute; display: flex; align-items: center; width: 100%; height: 100%;"
        :style="{ marginTop: isLogoVisible ? '0' : '20px' }"
      >
        <div style="width: 100%;">
          <div class="title">{{ getI18nMessage('title') }}</div>
          <div class="description">{{ getI18nMessage('description') }}</div>
          <div class="input-title" style="margin-top: 29px;">
            {{ getI18nMessage('emailLabel') }}
          </div>
          <div class="input-view" :class="isProcessing ? 'disabled' : ''">
            <input
              ref="emailTextfield"
              type="email"
              autocomplete="off"
              id="input-box"
              :placeholder="getI18nMessage('emailPlaceholder')"
              v-model="email"
            />
            <div
              v-if="email.length > 0"
              class="clickable"
              style="display: flex; align-items: center; margin-right: 8px; margin-left: 8px;"
              @click="clearEmail"
            >
              <img src="@/assets/icons/ic-close-small-light.svg" />
            </div>
          </div>
          <div v-if="errorMessage.length > 0" class="error" style="margin-top: 4px;">
            {{ errorMessage }}
          </div>
          <div
            v-if="!isProcessing"
            class="send-button"
            :class="
              email.length > 0 && !linkDidSent && diffSec == 0
                ? 'button-enabled'
                : 'button-disabled'
            "
            @click="sendLink"
          >
            {{
              diffSec > 0
                ? `${getI18nMessage('resend')} (${diffSec})`
                : linkDidSent
                ? getI18nMessage('linkSent')
                : getI18nMessage('sendLink')
            }}
          </div>
          <div v-else class="send-button button-loading">
            <div class="loader" style="overflow: hidden;">Loading...</div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { get } from 'lodash';
import { getErrorEmailValidation } from '@/utils/fieldValidation';
import { requestChangePasswordEmail } from '@/services/userService';
import moment from 'moment';

const i18n = {
  title: {
    th: 'เปลี่ยนรหัสผ่านของคุณ',
    en: 'Change Your Password',
  },
  description: {
    th: 'ระบุอีเมลที่คุณใช้สมัครสมาชิก ViaBus แล้วเราจะส่งลิงก์เปลี่ยนรหัสผ่านไปที่อีเมลของคุณ',
    en: 'Enter the email you signed up with us, and we’ll email a link to change your password.',
  },
  emailLabel: {
    th: 'อีเมล',
    en: 'Email',
  },
  emailPlaceholder: {
    th: 'กรอกอีเมลของคุณ',
    en: 'Enter your email here',
  },
  sendLink: {
    th: 'ส่งลิงก์',
    en: 'Send Link',
  },
  linkSent: {
    th: 'ส่งลิงก์ไปที่อีเมลของคุณแล้ว!',
    en: 'Link Sent to Email!',
  },
  cannotConnect: {
    th: 'มีบางอย่างขัดข้อง กรุณาส่งอีกครั้ง',
    en: 'Something went wrong, please try again',
  },
  resend: {
    th: 'ส่งอีเมลอีกครั้ง',
    en: 'Resend Email',
  },
  notVerify: {
    th: 'อีเมลนี้ยังไม่ได้ยืนยันสมาชิก',
    en: 'This email has not been verified.',
  },
};

const LATEST_REQUEST_UNIX_TIME = 'LATEST_REQUEST_UNIX_TIME';

export default {
  components: {},
  computed: {},
  data() {
    return {
      email: '',
      language: 'en',
      errorMessage: '',
      linkDidSent: false,
      isProcessing: false,
      isLogoVisible: true,
      countDownInterval: null,
      diffSec: 0,
    };
  },
  watch: {
    email() {
      if (this.errorMessage.length > 0) {
        this.errorMessage = '';
      }
      if (this.linkDidSent) {
        this.linkDidSent = false;
      }
    },
    diffSec() {
      if (this.diffSec == 0) {
        clearInterval(this.countDownInterval);
      }
    },
  },
  methods: {
    getI18nMessage(key) {
      return get(i18n, `${key}.${this.language}`, '');
    },
    clearEmail() {
      this.email = '';
      this.$refs.emailTextfield.focus();
    },
    sendLink() {
      if (this.diffSec != 0) {
        return;
      }
      this.errorMessage = '';
      const errorMessage = getErrorEmailValidation(this.email, this.language);
      if (errorMessage) {
        this.errorMessage = errorMessage;
        return;
      }
      this.isProcessing = true;
      requestChangePasswordEmail(this.email)
        .then(() => {
          localStorage[LATEST_REQUEST_UNIX_TIME] = new Date().getTime() / 1000;
          this.diffSec = 60;
          this.startCountdown();
          this.linkDidSent = true;
        })
        .catch(err => {
          let statusCode = get(err, 'response.data.stat');
          if (statusCode == 403) {
            this.errorMessage = this.getI18nMessage('notVerify');
          } else {
            this.errorMessage = get(
              err,
              'response.data.info',
              this.getI18nMessage('cannotConnect')
            );
          }
        })
        .finally(() => {
          this.isProcessing = false;
        });
    },
    onWindowResize() {
      this.setLogoVisible();
    },
    setLogoVisible() {
      this.isLogoVisible = window.innerHeight > 380;
    },
    setUpCountdown() {
      let unixTime = localStorage[LATEST_REQUEST_UNIX_TIME];
      if (unixTime != null) {
        let diffSec = moment().diff(moment.unix(unixTime), 'second');
        if (!Number.isNaN(diffSec) && diffSec < 60) {
          this.diffSec = 60 - diffSec;
          this.startCountdown();
        } else {
          localStorage[LATEST_REQUEST_UNIX_TIME] = null;
        }
      }
    },
    startCountdown() {
      if (this.diffSec > 0) {
        this.countDownInterval = setInterval(() => {
          this.diffSec -= 1;
        }, 1000);
      }
    },
  },
  mounted() {
    let lang = get(this.$route.query, 'lang', 'en').trim();
    if (lang === 'en' || lang === 'th') {
      this.language = lang;
    }
    this.setUpCountdown();
    this.setLogoVisible();

    window.addEventListener('resize', this.onWindowResize);
  },
  beforeDestroy() {
    clearInterval(this.countDownInterval);
    this.countDownInterval = null;
    window.removeEventListener('resize', this.onWindowResize);
  },
};
</script>

<style scoped>
@import '../css/spinner.css';

section {
  font-family: 'ViaNotoSans';
}

.title {
  font-size: 24px;
  font-weight: 700;
  color: #263373;
  margin-left: 16px;
  margin-top: 40px;
}

.description {
  font-size: 15px;
  font-weight: 500;
  line-height: 1.47;
  color: #7a88b8;
  margin-top: 23px;
  margin-left: 16px;
  margin-right: 16px;
}

.input-title {
  font-size: 13px;
  font-weight: 500;
  color: #7a88b8;
  margin: 0 16px;
}

#input-box::placeholder {
  font-size: 15px;
  font-weight: 500;
  color: #9ca6c9;
}

.input-view {
  border-radius: 4px;
  margin-left: 16px;
  margin-right: 16px;
  margin-top: 12px;
  height: 48px;
  display: flex;
  align-items: center;
  background: #edeff7;
}

#input-box {
  width: 100%;
  height: 48px;
  border-radius: 4px;
  font-family: 'ViaNotoSans';
  font-size: 15px;
  font-weight: 500;
  color: #9ca6c9;
  background-color: #edeff7;
  border: 0;
  padding: 0 12px;
  color: #263373;
}

.send-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background-color: #dbe0f0;
  margin: 40px 16px;
  height: 48px;
}

.clickable {
  cursor: pointer;
  user-select: none;
}

.error {
  color: #ff335c;
  font-size: 13px;
  font-weight: 500;
  margin: 0 16px;
}

.button-enabled {
  cursor: pointer;
  user-select: none;
  font-size: 17px;
  font-weight: 600;
  color: white;
  background-color: #4d6aff;
}

.button-disabled {
  font-size: 17px;
  font-weight: 600;
  pointer-events: none;
  color: #9ca6c9;
  background-color: #dbe0f0;
}

.button-loading {
  pointer-events: none;
  background-color: #4d6aff;
  opacity: 0.8;
}

.disabled {
  pointer-events: none;
  opacity: 0.8;
}
</style>
